import type { ThemeConfig } from 'antd';

/** iPadOS / Apple HIG 取向的 Ant Design 主題 */
export const crmAppleTheme: ThemeConfig = {
  token: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", "Helvetica Neue", "PingFang TC", "Noto Sans TC", sans-serif',
    fontSize: 15,
    colorPrimary: '#007AFF',
    colorLink: '#007AFF',
    colorText: '#1D1D1F',
    colorTextSecondary: '#6E6E73',
    colorTextTertiary: '#86868B',
    colorBorder: 'rgba(60, 60, 67, 0.12)',
    colorBorderSecondary: 'rgba(60, 60, 67, 0.08)',
    colorBgLayout: '#F2F2F7',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FFFFFF',
    borderRadius: 12,
    borderRadiusLG: 16,
    controlHeight: 44,
    lineHeight: 1.47,
    boxShadow:
      '0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 24px rgba(0, 0, 0, 0.06)',
    boxShadowSecondary: '0 1px 3px rgba(0, 0, 0, 0.06)',
  },
  components: {
    Layout: {
      siderBg: '#F5F5F7',
      headerBg: 'transparent',
      bodyBg: '#F2F2F7',
    },
    Card: {
      paddingLG: 22,
      borderRadiusLG: 16,
    },
    Table: {
      headerBg: '#FAFAFC',
      headerColor: '#6E6E73',
      headerSplitColor: 'rgba(60, 60, 67, 0.08)',
      borderColor: 'rgba(60, 60, 67, 0.08)',
      cellPaddingBlock: 11,
      cellPaddingInline: 12,
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: 'rgba(0, 122, 255, 0.12)',
      itemSelectedColor: '#007AFF',
      itemHoverBg: 'rgba(60, 60, 67, 0.06)',
      itemHeight: 44,
      iconSize: 18,
      activeBarBorderWidth: 0,
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      borderRadius: 10,
    },
    Input: {
      activeBorderColor: '#007AFF',
      hoverBorderColor: 'rgba(60, 60, 67, 0.2)',
      paddingBlock: 10,
    },
    Drawer: {
      borderRadiusLG: 0,
    },
  },
};
